<div class="vendor-details">
  <div class="card-container">
    <!-- About card -->
    <div class="col">
      <emerald-card>
        <div class="content-container">
          <div class="header-row">
            <div class="heading-title">{{ vendorProfileInfo.labelAbout }}</div>
          </div>
          <div class="details">
            <ng-container>
              <p *ngFor="let detail of aboutDetails">
                <strong>{{ detail.label }}</strong>
                <span>{{ about[detail.key] || '-' }}</span>
              </p>
            </ng-container>
          </div>
        </div>
      </emerald-card>
    </div>

    <!-- Contact cards -->
    <div class="col" *ngFor="let contact of vendorContact">
      <emerald-card>
        <div class="content-container">
          <div class="header-row">
            <div class="heading-title">{{ headerText.ContactInformation }}</div>
          </div>
          <div class="details">
            <ng-container>
              <p *ngFor="let detail of contactDetails">
                <strong>{{ detail.label }}</strong>
                <span>{{ contact[detail.key] || '-' }}</span>
              </p>
            </ng-container>
          </div>
        </div>
      </emerald-card>
    </div>
  </div>
</div>
